import { render, staticRenderFns } from "./ManageSubcontract.vue?vue&type=template&id=190dd7dc&scoped=true&"
import script from "./ManageSubcontract.vue?vue&type=script&lang=js&"
export * from "./ManageSubcontract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190dd7dc",
  null
  
)

export default component.exports